import '../style/flex-layout-C5qyH8ZZ.css'
import { createVNode as Q, ref as F, reactive as Oe, onMounted as be, computed as S, provide as Fe, h as Xe, Teleport as ut, inject as He, unref as o, defineComponent as j, toRefs as Ie, watch as fe, nextTick as Ye, openBlock as l, createElementBlock as N, normalizeClass as D, createBlock as U, resolveDynamicComponent as G, createCommentVNode as $, createElementVNode as q, toDisplayString as Be, withCtx as Ce, Fragment as W, renderList as ee, createTextVNode as nt, toRef as xe, onUnmounted as ft, normalizeStyle as V, onErrorCaptured as gt, renderSlot as ht, mergeProps as st, onUpdated as pt, onBeforeUnmount as Tt, normalizeProps as Ke, guardReactiveProps as qe } from "vue";
import { CLASSES as b } from "./layout/Types.js";
import { useStyledLog as at } from "./hooks/useStyledLog.js";
import { DockLocation as J } from "./layout/DockLocation.js";
import { DragDrop as de } from "./layout/DragDrop.js";
import { Actions as Y } from "./layout/model/Actions.js";
import { TabNode as ye } from "./layout/model/TabNode.js";
import { Rect as ce } from "./layout/Rect.js";
import We from "./icon.js";
import { Orientation as ne } from "./layout/Orientation.js";
import { SplitterNode as Je } from "./layout/model/SplitterNode.js";
import { TabSetNode as we } from "./layout/model/TabSetNode.js";
import { reactiveComputed as Ve, useElementBounding as Me, useElementSize as yt, watchDebounced as vt } from "@vueuse/core";
import { ICloseType as De } from "./layout/model/ICloseType.js";
import { I18nLabel as ue } from "./layout/I18nLabel.js";
import bt, { MenuList as _t, MenuItem as mt } from "./menu.js";
import { BorderNode as Le } from "./layout/model/BorderNode.js";
import { TAB_PANEL_PROVIDER as Rt } from "./constant/providers.js";
const Te = (t, e = 16) => Q(We, {
  icon: t,
  size: e
}, null), it = {
  close: Te("cross"),
  closeTabset: Te("cross", 18),
  popout: Te("external"),
  maximize: Te("arrow-expand", 16),
  restore: Te("arrow-collapse", 16),
  more: Te("caret-down")
};
function Et(t) {
  const e = typeof window < "u" && (window.document.documentMode || /Edge\//.test(window.navigator.userAgent)), i = typeof window < "u" && window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches && !e, s = t !== void 0 ? t : i;
  return {
    isSupportsPopout: () => s,
    supportsPopout: s
  };
}
function Ct() {
  const t = F(null);
  return {
    selfRef: t,
    getDomRect: () => t.value.getBoundingClientRect(),
    getRootDiv: () => t.value,
    getCurrentDocument: () => t.value.ownerDocument
  };
}
function Lt(t) {
  const { supportsPopout: e, isSupportsPopout: n } = Et(t.supportsPopout), { selfRef: i, getDomRect: s, getRootDiv: a, getCurrentDocument: r } = Ct(), c = F(), p = at({ enabled: t.logEnabled, plain: !0 }), u = Oe({
    rect: new ce(0, 0, 0, 0),
    editingTab: void 0,
    showHiddenBorder: J.CENTER,
    showEdges: !1
  }), _ = (h) => t.classNameMapper === void 0 ? h : t.classNameMapper(h), f = (h) => {
    const w = {
      stickyButtons: [],
      buttons: [],
      headerButtons: []
    };
    return t.onRenderTabSet && t.onRenderTabSet(h, w), w;
  }, R = (h, w) => {
    t.onRenderTab && t.onRenderTab(h, w);
  }, I = (h, w) => {
    let P;
    return t.i18nMapper && (P = t.i18nMapper(h, w)), P === void 0 && (P = h + (w === void 0 ? "" : w)), P;
  }, E = (h) => (t.font && (i.value && (t.font.size && i.value.style.setProperty("--font-size", t.font.size), t.font.family && i.value.style.setProperty("--font-family", t.font.family)), t.font.style && (h.fontStyle = t.font.style), t.font.weight && (h.fontWeight = t.font.weight)), h), O = () => t.realtimeResize ?? !1, C = () => t.onTabSetPlaceHolder, x = (h) => {
    if (t.onAction !== void 0) {
      const w = t.onAction(h);
      return w !== void 0 ? t.model.doAction(w) : void 0;
    } else
      return p.info("[FlexLayout] doAction:", h), t.model.doAction(h);
  }, m = (h = s()) => {
    const w = new ce(0, 0, h.width, h.height);
    !w.equals(u.rect) && w.width !== 0 && w.height !== 0 && (u.rect = w);
  };
  let v, k;
  const M = Oe({
    show: !1,
    text: void 0,
    node: null,
    json: null,
    position: {
      x: 0,
      y: 0
    },
    containerRect: {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    }
  }), z = Oe({
    show: !1,
    className: "",
    rect: new ce(0, 0, 0, 0)
  });
  let y = "", d, B;
  const g = 100, T = 10;
  let A, L;
  const H = t.popoutURL ? t.popoutURL : "popout.html";
  function te(h, w, P, K, ae, ie) {
    K ? (k = P, y = w, de.instance.startDrag(h, se, oe, le, ze, ae, ie, L, i.value)) : de.instance.startDrag(h, void 0, void 0, void 0, void 0, ae, ie, L, i.value);
  }
  function se() {
    if (d = void 0, B = void 0, z.show = !1, M.show = !0, M.text = y, M.node = k, M.json = v, t.model.getMaximizedTabset() === void 0 && (u.showEdges = !0), k !== void 0 && k instanceof ye) {
      const h = k.getTabRect();
      h && (z.rect = h), p.info("[FlexLayout] onDragStart -> outlineProps.rect: ", h);
    }
    return !0;
  }
  function oe(h) {
    const w = s(), P = {
      x: h.clientX - w.left,
      y: h.clientY - w.top
    };
    me(P.x, P.y), M.position = P, M.containerRect = w;
    const K = t.model._findDropTargetNode(k, P.x, P.y);
    K && (t.onTabDrag || (d = K, p.info("[FlexLayout] onDragMove -> dropInfo.rect: ", d.rect), z.rect = d.rect, z.show = !0, z.className = d.className));
  }
  function le(h) {
    if (M.show = !1, M.node = null, z.show = !1, u.showEdges = !1, p.info("[FlexLayout] onDragEnd"), _e(), de.instance.hideGlass(), d)
      if (B) {
        v = void 0;
        try {
          const { callback: w, dragging: P, over: K, x: ae, y: ie, location: ke } = B;
          w(P, K, ae, ie, ke), A != null && (A(), A = void 0);
        } catch (w) {
          console.error(w);
        }
      } else if (v !== void 0) {
        const w = x(Y.addNode(v, d.node.getId(), d.location, d.index));
        A != null && (A(w, h), A = void 0), v = void 0;
      } else k !== void 0 && x(Y.moveNode(k.getId(), d.node.getId(), d.location, d.index));
    u.showHiddenBorder = J.CENTER;
  }
  function ze(h) {
    if (h) {
      z.show = !1, M.show = !1, M.node = null, _e(), u.showEdges = !1, A != null && (A(), A = void 0);
      try {
        B?.invalidated?.();
      } catch (w) {
        console.error(w);
      }
      de.instance.hideGlass(), v = void 0, B = void 0;
    }
    u.showHiddenBorder = J.CENTER;
  }
  function Pe(h, w) {
    const P = Xe(ut, {
      to: w
    }, h);
    c.value = P;
  }
  function _e() {
    c.value = void 0;
  }
  function me(h, w) {
    const P = t.model._getOuterInnerRects().outer, K = P.getCenter(), ae = T, ie = g / 2;
    let ke = !1;
    t.model.isEnableEdgeDock() && u.showHiddenBorder === J.CENTER && (w > K.y - ie && w < K.y + ie || h > K.x - ie && h < K.x + ie) && (ke = !0);
    let pe = J.CENTER;
    ke || (h <= P.x + ae ? pe = J.LEFT : h >= P.getRight() - ae ? pe = J.RIGHT : w <= P.y + ae ? pe = J.TOP : w >= P.getBottom() - ae && (pe = J.BOTTOM)), pe !== u.showHiddenBorder && (u.showHiddenBorder = pe);
  }
  function Re(h) {
    t.onModelChange && t.onModelChange(t.model, h);
  }
  function Ae(h) {
    x(Y.unFloatTab(h));
    try {
      t.model.getNodeById(h)._setWindow(void 0);
    } catch {
    }
  }
  function Ne(h, w) {
    t.model.getNodeById(h)._setWindow(w);
  }
  function $e(h, w) {
    t.model.getNodeById(h) !== void 0 && x(Y.addNode(w, h, J.CENTER, -1));
  }
  function ge(h, w) {
    t.model.getNodeById(h) !== void 0 && x(Y.updateNodeAttributes(h, w));
  }
  function he(h) {
    x(Y.deleteTabByID(h));
  }
  function Se(h, w, P) {
    A = P, v = w, te(void 0, h, ye._fromJson(w, t.model, !1), !0, void 0, void 0);
  }
  function X(h, w, P) {
    A = P, v = w, de.instance.addGlass(Ee);
    const K = s();
    M.show = !0, M.text = h, M.json = v, M.containerRect = K, M.position = {
      x: K.width / 2,
      y: K.height / 2
    };
  }
  function Ee() {
    M.show = !1;
  }
  function Ze(h) {
    const w = h.isMaximized();
    x(Y.maximizeToggle(h.getId(), !w));
  }
  be(() => {
    L = i.value.ownerDocument, L.defaultView;
  });
  const dt = {
    model: t.model,
    getClassName: _,
    maximize: Ze,
    customizeTabSet: f,
    customizeTab: R,
    isSupportsPopout: n,
    i18nName: I,
    styleFont: E,
    getEditingTab: () => u.editingTab,
    showPortal: Pe,
    hidePortal: _e,
    setEditingTab(h) {
      u.editingTab = h;
    },
    getDomRect: s,
    getCurrentDocument: r,
    getRootDiv: a,
    isRealtimeResize: O,
    doAction: x,
    dragNode: S(() => M.node),
    dragStart: te,
    factory: t.factory,
    icons: it,
    iconFactory: t.iconFactory,
    titleFactory: t.titleFactory,
    getTabSetPlaceHolderCallback: C,
    onError: t.onError
  };
  return Fe("layout", dt), {
    selfRef: i,
    portal: c,
    state: u,
    supportsPopout: e,
    updateRect: m,
    getClassName: _,
    i18nName: I,
    styleFont: E,
    getDomRect: s,
    onModelChange: Re,
    doAction: x,
    addTabToTabSet: $e,
    addTabWithDragAndDrop: Se,
    replaceTab: ge,
    removeTab: he,
    onCloseWindow: Ae,
    onSetWindow: Ne,
    maximize: Ze,
    popoutURL: H,
    addTabWithDragAndDropIndirect: X,
    dragRectProps: M,
    outlineProps: z
  };
}
function Bt() {
  const t = F(null), e = F(null), n = F(null), i = Oe({
    headerBarSize: 32,
    tabBarSize: 36,
    borderBarSize: 40
  });
  return {
    findHeaderBarSizeRef: t,
    findTabBarSizeRef: e,
    findBorderBarSizeRef: n,
    metrics: i,
    updateLayoutMetrics: () => {
      if (t.value) {
        const a = t.value.getBoundingClientRect().height;
        i.headerBarSize = a;
      }
      if (e.value) {
        const a = e.value.getBoundingClientRect().height;
        i.tabBarSize = a;
      }
      if (n.value) {
        const a = n.value.getBoundingClientRect().height;
        i.borderBarSize = a;
      }
    }
  };
}
function wt() {
  const t = F([]), e = F([]), n = F([]), i = F({}), s = F([]);
  return {
    borderComponents: t,
    tabComponents: i,
    tabSetComponents: e,
    floatingWindows: n,
    splitterComponents: s,
    resetComponents: () => {
      t.value = [], e.value = [], n.value = [], i.value = {}, s.value = [];
    }
  };
}
function At(t) {
  const e = {}, n = t._getAttr("overflow");
  return n && (e.overflow = n), e;
}
function Nt(t) {
  const {
    iconFactory: e,
    titleFactory: n,
    icons: i,
    factory: s,
    supportsPopout: a,
    popoutURL: r,
    getDomRect: c,
    onTabConfigChange: p,
    onSetWindow: u,
    onCloseWindow: _
  } = t;
  function f(E) {
    const O = E.getRect().clone(), C = c(), x = Math.min(80, window.outerHeight - window.innerHeight), m = Math.min(80, window.outerWidth - window.innerWidth);
    return O.x = O.x + C.x + window.screenX + m, O.y = O.y + C.y + window.screenY + x, O;
  }
  function R(E, O, C, x, m, v) {
    const k = O._getDrawChildren();
    let M = 0, z = 0, y = 0;
    for (const d of k)
      if (d instanceof Je) {
        const B = E + "/s" + M++;
        v.push({
          key: d.getId(),
          path: B,
          node: d,
          rect: d.getRect()
        });
      } else if (d instanceof we) {
        const B = E + "/ts" + y++, g = d.getRect();
        C.push({
          key: d.getId(),
          path: B,
          node: d,
          rect: g,
          iconFactory: e,
          titleFactory: n,
          icons: i
        }), R(B, d, C, x, m, v);
      } else if (d instanceof ye) {
        const B = E + "/t" + z++, g = d.getParent().getChildren()[d.getParent().getSelected()];
        if (g === void 0 && console.warn("undefined selectedTab should not happen"), !(a && d.isFloating())) {
          const T = d.getConfig(), A = At(d);
          x[d.getId()] = {
            key: d.getId(),
            path: B,
            node: d,
            rect: d.getRect(),
            style: A,
            selected: g === d,
            factory: s,
            state: T,
            onStateChange: (L) => {
              p?.(d, L);
            }
          };
        }
      } else {
        const B = E + (d.getOrientation() === ne.HORZ ? "/r" : "/c") + y++;
        R(B, d, C, x, m, v);
      }
  }
  function I(E, O, C, x, m) {
    for (const v of E.getBorders()) {
      const k = `/border/${v.getLocation().getName()}`;
      if (v.isShowing()) {
        O.push({
          key: `border_${v.getLocation().getName()}`,
          path: k,
          node: v,
          rect: v.getRect(),
          iconFactory: e,
          titleFactory: n,
          icons: i
        });
        const M = v._getDrawChildren();
        let z = 0, y = 0;
        for (const d of M)
          if (d instanceof Je) {
            const B = k + "/s";
            m.push({
              key: d.getId(),
              path: B,
              node: d,
              rect: d.getRect()
            });
          } else if (d instanceof ye) {
            const B = k + "/t" + y++;
            if (a && d.isFloating()) {
              const g = f(d);
              x.push({
                key: d.getId(),
                url: r,
                rect: g,
                title: d.getName(),
                id: d.getId(),
                onSetWindow: u,
                onCloseWindow: _
              }), C[d.getId()] = {
                key: d.getId(),
                path: B,
                node: d,
                rect: d.getRect(),
                selected: z === v.getSelected(),
                factory: s,
                onStateChange: (T) => {
                  p?.(d, T);
                }
              };
            } else
              C[d.getId()] = {
                key: d.getId(),
                path: B,
                node: d,
                rect: d.getRect(),
                selected: z === v.getSelected(),
                factory: s,
                onStateChange: (g) => {
                  p?.(d, g);
                }
              };
            z++;
          }
      }
    }
  }
  return {
    renderChildren: R,
    renderBorder: I
  };
}
function Z() {
  return He("layout");
}
function St() {
  return He("borderSet", {
    rect: new ce(0, 0, 0, 0)
  });
}
function kt(t) {
  return t.titleContent !== void 0;
}
function Ge(t) {
  const { iconFactory: e, titleFactory: n } = Z(), { node: i, title: s } = t;
  return Ve(() => {
    const r = o(i), c = o(n), p = o(e);
    let u = o(s);
    if (c) {
      const R = c(r);
      R !== void 0 && (typeof R == "string" ? u = R : kt(R) ? u = R.titleContent : u = R);
    }
    let _ = p ? p(r) : null;
    const f = r.getIcon();
    return _ === null && f !== void 0 && (_ = Xe("img", {
      style: { width: "1em", height: "1em" },
      src: f,
      alt: "leadingContent"
    })), {
      // should create a pure text node
      content: typeof u == "string" ? Xe("span", u) : u,
      leading: _
    };
  });
}
function lt(t, e) {
  e ? t.visibility = "hidden" : t.display = "none";
}
function ve(t) {
  let e = !1;
  return t instanceof MouseEvent && (t.button !== 0 || t.ctrlKey || t.altKey || t.metaKey || t.shiftKey) && (e = !0), e;
}
const Ot = ["title"], xt = {
  key: 0,
  class: "flexlayout__border_button_leading"
}, Mt = {
  key: 1,
  class: "flexlayout__tab_button_textbox"
}, Dt = ["value"], Ft = {
  key: 2,
  class: "flexlayout__border_button_content"
}, It = ["data-layout-path", "title"], Ut = /* @__PURE__ */ j({
  __name: "BorderButton",
  props: {
    node: {},
    selected: { type: Boolean },
    border: {},
    title: {},
    path: {}
  },
  setup(t) {
    const e = t, n = Z(), { icons: i } = n, { node: s, title: a } = Ie(e), r = Ge({
      node: s,
      title: a
    }), { rect: c } = St(), p = F(null), u = F(null);
    fe(c, () => {
      Ye(m);
    });
    const _ = (y) => {
      !ve(y) && !n.getEditingTab() && n.dragStart(y, void 0, e.node, e.node.isEnableDrag(), I, E);
    }, f = (y) => {
      ve(y) && n.auxMouseClick(e.node, y);
    }, R = (y) => {
      n.showContextMenu(e.node, y);
    }, I = () => {
      n.doAction(Y.selectTab(e.node.getId()));
    }, E = (y) => {
    }, O = () => {
      const y = e.node.getCloseType();
      return !!(e.selected || y === De.Always || y === De.Visible && window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches);
    }, C = () => {
      O() ? n.doAction(Y.deleteTab(e.node)) : I();
    }, x = (y) => {
      y.stopPropagation();
    };
    be(() => {
      m(), n.getEditingTab() === e.node && u.value.select();
    });
    const m = () => {
      if (!p.value) return;
      const y = n.getDomRect(), d = p.value.getBoundingClientRect();
      e.node._setTabRect(new ce(d.left - y.left, d.top - y.top, d.width, d.height));
    }, v = (y) => {
      y.stopPropagation();
    }, k = (y) => {
      y.keyCode === 27 ? n.setEditingTab(void 0) : y.keyCode === 13 && (n.setEditingTab(void 0), n.doAction(Y.renameTab(e.node.getId(), y.target?.value)));
    }, M = n.getClassName, z = S(() => {
      const y = [M(b.FLEXLAYOUT__BORDER_BUTTON)];
      y.push(e.selected ? M(b.FLEXLAYOUT__BORDER_BUTTON__SELECTED) : M(b.FLEXLAYOUT__BORDER_BUTTON__UNSELECTED));
      const d = e.node.getClassName();
      return d && y.push(d), y;
    });
    return (y, d) => (l(), N("div", {
      ref_key: "selfRef",
      ref: p,
      class: D(z.value),
      title: o(s).getHelpText(),
      onMousedown: _,
      onClick: f,
      onAuxclick: f,
      onContextmenu: R,
      onTouchstart: _
    }, [
      o(r).leading ? (l(), N("div", xt, [
        (l(), U(G(o(r).leading)))
      ])) : $("", !0),
      o(n).getEditingTab() === o(s) ? (l(), N("div", Mt, [
        q("input", {
          ref_key: "contentRef",
          ref: u,
          type: "text",
          value: o(s).getName(),
          autofocus: "",
          onKeydown: k,
          onMousedown: v,
          onTouchstart: v
        }, null, 40, Dt)
      ])) : o(r).content ? (l(), N("div", Ft, [
        (l(), U(G(o(r).content)))
      ])) : $("", !0),
      o(s).isEnableClose() ? (l(), N("div", {
        key: "close",
        "data-layout-path": `${e.path}/button/close`,
        title: o(n).i18nName(o(ue).Close_Tab),
        class: D(o(M)(o(b).FLEXLAYOUT__BORDER_BUTTON_TRAILING)),
        onMousedown: x,
        onClick: C,
        onTouchstart: x
      }, [
        o(i).close ? (l(), U(G(typeof o(i).close == "function" ? o(i).close(o(s)) : o(i).close), { key: 0 })) : $("", !0)
      ], 42, It)) : $("", !0)
    ], 42, Ot));
  }
}), zt = ["title"], Pt = { key: 2 }, rt = /* @__PURE__ */ j({
  __name: "TabButtonStamp",
  props: {
    node: {},
    title: {}
  },
  setup(t) {
    const e = t, { node: n, title: i } = Ie(e), s = Z(), a = Ge({
      node: n,
      title: i
    }), r = F(null), c = s.getClassName, p = c(b.FLEXLAYOUT__TAB_BUTTON_STAMP);
    return (u, _) => (l(), N("div", {
      ref_key: "selfRef",
      ref: r,
      class: D(o(p)),
      title: o(n).getHelpText()
    }, [
      o(a).leading ? (l(), U(G(o(a).leading), {
        key: 0,
        class: D(o(c)(o(b).FLEXLAYOUT__TAB_BUTTON_LEADING))
      }, null, 8, ["class"])) : $("", !0),
      o(a).content ? (l(), U(G(o(a).content), {
        key: 1,
        class: D(o(c)(o(b).FLEXLAYOUT__TAB_BUTTON_CONTENT))
      }, null, 8, ["class"])) : (l(), N("div", Pt, Be(o(n)._getNameForOverflowMenu()), 1))
    ], 10, zt));
  }
}), $t = { "data-layout-path": "/popup-menu" }, Xt = { class: "flexlayout__tab_button_overflow" }, Yt = { key: 0 }, Ht = /* @__PURE__ */ j({
  __name: "PopupMenu",
  props: {
    items: {}
  },
  setup(t) {
    const e = Z(), n = F(!1), i = (s, a) => {
      e.doAction(Y.selectTab(s.node.getId())), a?.stopPropagation();
    };
    return (s, a) => (l(), N("div", $t, [
      Q(o(bt), {
        open: n.value,
        "onUpdate:open": a[0] || (a[0] = (r) => n.value = r),
        "trigger-by-hover": !1,
        "auto-select": !1,
        "render-trigger-button": !1
      }, {
        content: Ce(() => [
          Q(o(_t), null, {
            default: Ce(() => [
              (l(!0), N(W, null, ee(s.items, (r) => (l(), U(o(mt), {
                key: r.index,
                onClick: (c) => i(r, c)
              }, {
                default: Ce(() => [
                  r.node.getModel().isLegacyOverflowMenu() ? (l(), N("div", Yt, Be(r.node._getNameForOverflowMenu()), 1)) : (l(), U(rt, {
                    key: 1,
                    node: r.node,
                    title: r.node.getName()
                  }, null, 8, ["node", "title"]))
                ]),
                _: 2
              }, 1032, ["onClick"]))), 128))
            ]),
            _: 1
          })
        ]),
        default: Ce(() => [
          q("div", Xt, [
            nt(Be(s.items.length) + " ", 1),
            Q(o(We), {
              icon: "caret-down",
              size: 20,
              rotation: n.value ? 180 : 0
            }, null, 8, ["rotation"])
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ]));
  }
});
function Ue(t, e) {
  const n = t instanceof we, i = (f) => {
    if (!ve(f)) {
      let R = t.getName();
      if (R || (R = t.getChildren().map((I) => I.getName()).join(", ")), e.doAction(Y.setActiveTabset(t.getId())), !e.getEditingTab()) {
        const I = R;
        t.getModel().getMaximizedTabset() !== void 0 ? e.dragStart(f, I, t, !1, () => {
        }, _) : e.dragStart(
          f,
          I,
          t,
          n && t.isEnableDrag(),
          () => null,
          _
        );
      }
    }
  }, s = (f) => {
    ve(f) && e.auxMouseClick(t, f);
  }, a = (f) => {
    e.showContextMenu(t, f);
  }, r = (f) => {
    f.stopPropagation();
  }, c = (f) => {
    n && t.canMaximize() && e.maximize(t), f.stopPropagation();
  }, p = (f) => {
    e.doAction(Y.deleteTabset(t.getId())), f.stopPropagation();
  }, u = (f) => {
    const R = t.getSelectedNode();
    R !== void 0 && e.doAction(Y.floatTab(R.getId())), f.stopPropagation();
  }, _ = () => {
    n && t.canMaximize() && e.maximize(t);
  };
  return {
    onMousedown: i,
    onAuxMouseClick: s,
    onContextMenu: a,
    onInterceptMouseDown: r,
    onMaximizeToggle: c,
    onClose: p,
    onFloatTab: u,
    onDoubleClick: _
  };
}
const Wt = ["title", "onClick", "onMousedown", "onTouchstart"], je = /* @__PURE__ */ j({
  __name: "Toolbar",
  props: {
    node: {},
    path: {},
    buttons: {},
    stickyButtons: {},
    hiddenCount: {},
    hiddenTabs: {}
  },
  setup(t) {
    const e = t, { hiddenCount: n, hiddenTabs: i } = Ie(e), s = Z(), { onInterceptMouseDown: a, onFloatTab: r, onClose: c, onMaximizeToggle: p } = Ue(e.node, s), u = s.getClassName, _ = F(null), f = S(() => [u(b.FLEXLAYOUT__TAB_TOOLBAR)]), R = S(() => {
      const E = [], O = e.node.getSelectedNode();
      if (O !== void 0 && s.isSupportsPopout() && O.isEnableFloat() && !O.isFloating()) {
        const C = s.i18nName(ue.Float_Tab), x = typeof s.icons.popout == "function" ? s.icons.popout(O) : s.icons.popout;
        E.push({
          key: "float",
          dataLayoutPath: `${e.path}/button/float`,
          title: C,
          class: `${u(b.FLEXLAYOUT__TAB_TOOLBAR_BUTTON)} ${u(b.FLEXLAYOUT__TAB_TOOLBAR_BUTTON_FLOAT)}`,
          onClick: r,
          onMousedown: a,
          onTouchstart: a,
          icon: x
        });
      }
      if (e.node.canMaximize() && e.node.isShowMaximize()) {
        const C = s.i18nName(ue.Restore), x = s.i18nName(ue.Maximize), m = e.node.isMaximized() ? typeof s.icons.restore == "function" ? s.icons.restore(e.node) : s.icons.restore : typeof s.icons.maximize == "function" ? s.icons.maximize(e.node) : s.icons.maximize;
        E.push({
          key: "max",
          dataLayoutPath: `${e.path}/button/max`,
          title: e.node.isMaximized() ? C : x,
          class: `${u(b.FLEXLAYOUT__TAB_TOOLBAR_BUTTON)} ${u(b.FLEXLAYOUT__TAB_TOOLBAR_BUTTON_ + (e.node.isMaximized() ? "max" : "min"))}`,
          onClick: p,
          onMousedown: a,
          onTouchstart: a,
          icon: m
        });
      }
      if (!e.node.isMaximized() && e.node.isEnableClose()) {
        const C = s.i18nName(ue.Close_Tabset), x = typeof s.icons.closeTabset == "function" ? s.icons.closeTabset(e.node) : s.icons.closeTabset;
        E.push({
          key: "close",
          dataLayoutPath: `${e.path}/button/close`,
          title: C,
          class: `${u(b.FLEXLAYOUT__TAB_TOOLBAR_BUTTON)} ${u(b.FLEXLAYOUT__TAB_TOOLBAR_BUTTON_CLOSE)}`,
          onClick: c,
          onMousedown: a,
          onTouchstart: a,
          icon: x
        });
      }
      return E;
    }), I = S(() => e.buttons);
    return (E, O) => (l(), N("div", {
      ref: "toolbarRef",
      key: "toolbar",
      class: D(f.value),
      onMousedown: O[0] || (O[0] = //@ts-ignore
      (...C) => o(a) && o(a)(...C)),
      onTouchstart: O[1] || (O[1] = //@ts-ignore
      (...C) => o(a) && o(a)(...C)),
      onDragstart: O[2] || (O[2] = (C) => {
        C.preventDefault();
      })
    }, [
      o(n) ? (l(!0), N(W, { key: 0 }, ee(E.stickyButtons, (C, x) => (l(), U(G(C), { key: x }))), 128)) : $("", !0),
      o(n) ? (l(), U(Ht, {
        key: 1,
        ref_key: "overflowbuttonRef",
        ref: _,
        items: o(i)
      }, null, 8, ["items"])) : $("", !0),
      (l(!0), N(W, null, ee(I.value, (C, x) => (l(), N("button", { key: x }, [
        (l(), U(G(C)))
      ]))), 128)),
      (l(!0), N(W, null, ee(R.value, (C) => (l(), N("button", {
        key: C.key,
        title: C.title,
        class: D(C.class),
        onClick: C.onClick,
        onMousedown: C.onMousedown,
        onTouchstart: C.onTouchstart
      }, [
        (l(), U(G(C.icon)))
      ], 42, Wt))), 128))
    ], 34));
  }
});
function Vt(t) {
  const e = F(null), n = F(null), { width: i } = Me(e), { width: s } = Me(n);
  return fe([s, i], ([a, r], [c, p]) => {
    a > 0 && (a === c && r !== p || t());
  }), {
    stickyButtonsRef: e,
    toolbarRef: n,
    stickyButtonsWidth: i,
    toolbarWidth: s
  };
}
function ct(t) {
  const { node: e, selectedTabNode: n } = t, i = 2, s = F(null), a = F(0), r = F([]), c = F(0), p = F(!1), u = F(!0), { width: _ } = Me(s), { stickyButtonsRef: f, toolbarRef: R, stickyButtonsWidth: I, toolbarWidth: E } = Vt(() => {
    c.value !== r.value.length && m();
  }), O = S(() => e.value instanceof we ? e.value.isEnableTabStrip() === !0 : !0);
  fe(e, () => {
    a.value = 0, r.value = [], c.value = 0;
  }), fe([n, _], () => {
    setTimeout(() => {
      m();
    });
  }), fe(c, (v, k) => {
    (v === 0 || k === 0) && (a.value = 0);
  });
  const C = (v) => v.x, x = (v) => v.getRight();
  function m() {
    const v = e.value.getRect(), k = C(v), M = x(v) - I.value - E.value, z = e.value.getChildren();
    let y = n.value?.getTabRect();
    if (u.value && e.value instanceof Le && (y || (y = z[0].getTabRect(), u.value = !1)), !O.value || !M || !E.value || !y)
      return;
    const d = [];
    let B = 0;
    if (z.length) {
      const g = C(y) - i, T = x(y) + i;
      y.width + 2 * i >= M - k ? B = k - g : (T > M || g < k) && (g < k && (B = k - g), T + B > M && (B = M - T));
      const A = z[z.length - 1], L = Math.max(0, M - (x(A.getTabRect()) + i + B)), H = Math.min(0, a.value + B + L), te = H - a.value;
      for (let se = 0; se < z.length; se++) {
        const oe = z[se], le = oe.getTabRect();
        (C(le) + te < k || x(le) + te > M) && d.push({ node: oe, index: se });
      }
      a.value = H, c.value > 0 && (r.value = d), c.value = d.length;
    }
  }
  return {
    selfRef: s,
    stickyButtonsRef: f,
    toolbarRef: R,
    position: a,
    hiddenTabs: r,
    hiddenCount: c,
    userControlledLeft: p
  };
}
const Gt = ["data-layout-path"], jt = /* @__PURE__ */ j({
  __name: "BorderTabSet",
  props: {
    border: {},
    rect: {},
    path: {}
  },
  setup(t) {
    const e = Z(), n = t, i = xe(n, "border"), s = S(() => n.border.getSelectedNode()), { onContextMenu: a, onAuxMouseClick: r } = Ue(n.border, e), { selfRef: c, stickyButtonsRef: p, toolbarRef: u, hiddenTabs: _, hiddenCount: f, position: R, userControlledLeft: I } = ct({
      node: i,
      selectedTabNode: s
    }), E = S(() => {
      const g = n.border.getChildren(), T = [];
      for (let A = 0; A < g.length; A++) {
        const L = g[A];
        T.push({
          type: "border-button",
          key: L.getId(),
          title: L.getName(),
          path: `${n.path}/tb${A}`,
          border: n.border.getLocation().getName(),
          node: L,
          selected: n.border.getSelected() === A
        }), T.push({
          type: "divider",
          key: `divider${A}`
        });
      }
      return T;
    }), O = e.getClassName, C = S(() => n.rect.styleWithPosition({})), x = S(() => {
      const g = [O(b.FLEXLAYOUT__BORDER), O(b.FLEXLAYOUT__BORDER_ + n.border.getLocation().getName())], T = n.border.getClassName();
      return T && g.push(T), g;
    }), m = S(() => {
      const g = n.border.getBorderBarSize() - 1, T = n.border.getLocation();
      return T.equals(J.LEFT) ? { right: `${g}px`, height: `${g}px`, top: `${R.value}px` } : T.equals(J.RIGHT) ? { left: `${g}px`, height: `${g}px`, top: `${R.value}px` } : { height: `${g}px` };
    }), v = S(() => O(b.FLEXLAYOUT__BORDER_INNER) + " " + O(b.FLEXLAYOUT__BORDER_INNER_ + n.border.getLocation().getName())), k = S(() => O(b.FLEXLAYOUT__BORDER_TAB_DIVIDER)), M = S(() => {
      const g = n.border.getBorderBarSize() - 1, T = n.border.getLocation();
      return T.equals(J.LEFT) ? { right: g, height: g, top: R } : T.equals(J.RIGHT) ? { left: g, height: g, top: R } : { height: `${g}px`, left: `${R.value}px` };
    }), z = S(() => [
      O(b.FLEXLAYOUT__BORDER_INNER_TAB_CONTAINER),
      O(b.FLEXLAYOUT__BORDER_INNER_TAB_CONTAINER_ + n.border.getLocation().getName())
    ]);
    fe(
      () => n.border.getSelected(),
      () => {
        I.value = !1;
      }
    ), be(() => {
      document.addEventListener("mouseup", B), document.addEventListener("touchend", B);
    }), ft(() => {
      document.removeEventListener("mouseup", B), document.removeEventListener("touchend", B);
    });
    const y = S(() => e.customizeTabSet(n.border)), d = S(() => y.value.stickyButtons), B = () => {
      I.value = !1;
    };
    return Fe("borderSet", {
      rect: Ve(() => n.rect)
    }), (g, T) => (l(), N("div", {
      ref_key: "selfRef",
      ref: c,
      dir: "ltr",
      style: V(C.value),
      class: D(x.value),
      "data-layout-path": g.path,
      onClick: T[0] || (T[0] = //@ts-ignore
      (...A) => o(r) && o(r)(...A)),
      onAuxclick: T[1] || (T[1] = //@ts-ignore
      (...A) => o(r) && o(r)(...A)),
      onContextmenu: T[2] || (T[2] = //@ts-ignore
      (...A) => o(a) && o(a)(...A))
    }, [
      q("div", {
        style: V(m.value),
        class: D(v.value)
      }, [
        q("div", {
          style: V(M.value),
          class: D(z.value)
        }, [
          (l(!0), N(W, null, ee(E.value, (A) => (l(), N(W, null, [
            A.type === "border-button" ? (l(), U(Ut, {
              key: A.key,
              border: A.border,
              node: A.node,
              path: A.path,
              selected: A.selected,
              title: A.title
            }, null, 8, ["border", "node", "path", "selected", "title"])) : A.type === "divider" ? (l(), N("div", {
              key: A.key,
              class: D(k.value)
            }, null, 2)) : $("", !0)
          ], 64))), 256)),
          d.value.length && !o(f) ? (l(), N("div", {
            key: 0,
            ref_key: "stickyButtonsRef",
            ref: p,
            class: D(o(O)(o(b).FLEXLAYOUT__TAB_TOOLBAR_STICKY_BUTTONS_CONTAINER))
          }, [
            (l(!0), N(W, null, ee(d.value, (A, L) => (l(), U(G(A), { key: L }))), 128))
          ], 2)) : $("", !0)
        ], 6)
      ], 6),
      Q(je, {
        ref_key: "toolbarRef",
        ref: u,
        node: i.value,
        path: g.path,
        "sticky-buttons": d.value,
        "hidden-count": o(f),
        "hidden-tabs": o(_)
      }, null, 8, ["node", "path", "sticky-buttons", "hidden-count", "hidden-tabs"])
    ], 46, Gt));
  }
}), Zt = ["data-layout-path"], Kt = /* @__PURE__ */ j({
  __name: "Splitter",
  props: {
    node: {},
    path: {},
    rect: {}
  },
  setup(t) {
    const e = t, n = F([]), i = F(), s = e.node.getParent(), a = Z(), r = (m) => {
      de.instance.setGlassCursorOverride(
        e.node.getOrientation() === ne.HORZ ? "ns-resize" : "ew-resize"
      ), de.instance.startDrag(
        m,
        p,
        u,
        f,
        c,
        void 0,
        void 0,
        a.getCurrentDocument(),
        a.getRootDiv()
      ), n.value = s._getSplitterBounds(
        e.node,
        !0
      );
      const v = a.getRootDiv();
      i.value = a.getCurrentDocument().createElement(
        "div"
      ), i.value.style.position = "absolute", i.value.className = a.getClassName(
        b.FLEXLAYOUT__SPLITTER_DRAG
      ), i.value.style.cursor = e.node.getOrientation() === ne.HORZ ? "ns-resize" : "ew-resize";
      const k = e.node.getRect();
      e.node.getOrientation() === ne.VERT && k.width < 2 ? k.width = 2 : e.node.getOrientation() === ne.HORZ && k.height < 2 && (k.height = 2), k.positionElement(i.value), v.appendChild(i.value);
    }, c = () => {
      a.getRootDiv().removeChild(i.value);
    }, p = () => !0, u = (m) => {
      const v = a.getDomRect(), k = {
        x: m.clientX - v.left,
        y: m.clientY - v.top
      };
      i.value && (e.node.getOrientation() === ne.HORZ ? i.value.style.top = R(k.y - 4) + "px" : i.value.style.left = R(k.x - 4) + "px"), a.isRealtimeResize() && _();
    }, _ = () => {
      let m = 0;
      if (i.value && (e.node.getOrientation() === ne.HORZ ? m = i.value.offsetTop : m = i.value.offsetLeft), s instanceof Le) {
        const v = s._calculateSplit(e.node, m);
        a.doAction(Y.adjustBorderSplit(e.node.getParent().getId(), v));
      } else {
        const v = s._calculateSplit(e.node, m);
        v !== void 0 && a.doAction(Y.adjustSplit(v));
      }
    }, f = () => {
      _(), a.getRootDiv().removeChild(i.value);
    }, R = (m) => {
      const v = n.value;
      let k = m;
      return m < v[0] && (k = v[0]), m > v[1] && (k = v[1]), k;
    }, I = a.getClassName, E = S(() => e.node.getModel().getSplitterExtra()), O = S(() => {
      const m = e.rect.styleWithPosition({
        cursor: e.node.getOrientation() === ne.HORZ ? "ns-resize" : "ew-resize"
      });
      return !(s instanceof Le) && e.node.getModel().getMaximizedTabset() !== void 0 && (m.display = "none"), m;
    }), C = S(() => {
      const m = e.rect.clone();
      return m.x = 0, m.y = 0, e.node.getOrientation() === ne.VERT ? m.width += E.value : m.height += E.value, m.styleWithPosition({
        cursor: e.node.getOrientation() === ne.HORZ ? "ns-resize" : "ew-resize"
      });
    }), x = S(() => {
      const m = [
        I(b.FLEXLAYOUT__SPLITTER),
        I(b.FLEXLAYOUT__SPLITTER_ + e.node.getOrientation().getName())
      ];
      return s instanceof Le && m.push(I(b.FLEXLAYOUT__SPLITTER_BORDER)), m;
    });
    return (m, v) => (l(), N("div", {
      style: V(O.value),
      class: D(x.value),
      "data-layout-path": m.path,
      onTouchstart: r,
      onMousedown: r
    }, [
      E.value ? (l(), N("div", {
        key: 0,
        style: V(C.value),
        class: D(o(I)(o(b).FLEXLAYOUT__SPLITTER_EXTRA))
      }, null, 6)) : $("", !0)
    ], 46, Zt));
  }
}), re = 50, Qe = 100, qt = 10, Jt = /* @__PURE__ */ j({
  __name: "Edges",
  props: {
    centerRect: {}
  },
  setup(t) {
    const e = t, { getClassName: n } = Z(), i = S(() => n(b.FLEXLAYOUT__EDGE_RECT)), s = S(() => {
      const a = e.centerRect, r = Qe, c = qt, p = Qe / 2;
      return a ? {
        North: {
          top: a.y + "px",
          left: a.x + a.width / 2 - p + "px",
          width: r + "px",
          height: c + "px",
          borderBottomLeftRadius: re + "px",
          borderBottomRightRadius: re + "px"
        },
        West: {
          top: a.y + a.height / 2 - p + "px",
          left: a.x + "px",
          width: c + "px",
          height: r + "px",
          borderTopRightRadius: re + "px",
          borderBottomRightRadius: re + "px"
        },
        South: {
          top: a.y + a.height - c + "px",
          left: a.x + a.width / 2 - p + "px",
          width: r + "px",
          height: c + "px",
          borderTopLeftRadius: re + "px",
          borderTopRightRadius: re + "px"
        },
        East: {
          top: a.y + a.height / 2 - p + "px",
          left: a.x + a.width - c + "px",
          width: c + "px",
          height: r + "px",
          borderTopLeftRadius: re + "px",
          borderBottomLeftRadius: re + "px"
        }
      } : {};
    });
    return (a, r) => (l(), N(W, null, [
      q("div", {
        class: D(i.value),
        style: V(s.value.North)
      }, null, 6),
      q("div", {
        class: D(i.value),
        style: V(s.value.West)
      }, null, 6),
      q("div", {
        class: D(i.value),
        style: V(s.value.South)
      }, null, 6),
      q("div", {
        class: D(i.value),
        style: V(s.value.East)
      }, null, 6)
    ], 64));
  }
}), Qt = /* @__PURE__ */ j({
  __name: "ErrorBoundary",
  props: {
    message: {},
    node: {}
  },
  setup(t) {
    const e = t, n = F(!1), i = Z();
    return gt((s, a, r) => {
      console.debug(s), console.debug(r), n.value = !0, i.onError?.(s, e.node, r);
    }), (s, a) => n.value ? (l(), N("div", {
      key: 0,
      class: D(o(b).FLEXLAYOUT__ERROR_BOUNDARY_CONTAINER)
    }, [
      q("div", {
        class: D(o(b).FLEXLAYOUT__ERROR_BOUNDARY_CONTENT)
      }, Be(s.message), 3)
    ], 2)) : ht(s.$slots, "default", { key: 1 });
  }
}), eo = ["data-layout-path"], to = /* @__PURE__ */ j({
  __name: "Tab",
  props: {
    selected: { type: Boolean },
    node: {},
    rect: {},
    factory: { type: Function },
    path: {},
    onStateChange: { type: Function },
    state: {}
  },
  setup(t) {
    const e = t, n = Z(), i = S(() => !e.node.isEnableRenderOnDemand() || e.selected), s = () => {
      const E = e.node.getParent();
      E.getType() === we.TYPE && (E.isActive() || n.doAction(Y.setActiveTabset(E.getId())));
    }, a = n.getClassName, r = S(() => e.node.getModel().isUseVisibility()), c = S(() => e.node.getParent());
    function p() {
      return c.value instanceof we ? e.node.getModel().getMaximizedTabset() !== void 0 && !c.value.isMaximized() : !1;
    }
    const u = S(() => {
      const E = e.rect.styleWithPosition({});
      return (!e.selected || p()) && lt(E, r.value), E;
    }), _ = S(() => {
      const E = [a(b.FLEXLAYOUT__TAB)];
      return c.value instanceof Le && (E.push(a(b.FLEXLAYOUT__TAB_BORDER)), E.push(a(b.FLEXLAYOUT__TAB_BORDER_ + c.value.getLocation().getName()))), E;
    }), f = S(() => e.node.isVisible()), R = F(null), { height: I } = yt(R);
    return Fe(Rt, {
      active: f,
      panelSelector: `.${b.FLEXLAYOUT__TAB}`,
      panelBoxHeight: I,
      autoPanelHeight: !0
    }), (E, O) => (l(), N("div", {
      ref_key: "panel",
      ref: R,
      class: D(_.value),
      "data-layout-path": E.path,
      onTouchStart: s,
      style: V(u.value),
      onMousedown: s
    }, [
      Q(Qt, {
        message: o(n).i18nName(o(ue).Error_rendering_component),
        node: E.node
      }, {
        default: Ce(() => [
          i.value ? (l(), U(G(E.factory(E.node)), st({ key: 0 }, E.state, { "on-state-change": E.onStateChange }), null, 16, ["on-state-change"])) : $("", !0)
        ]),
        _: 1
      }, 8, ["message", "node"])
    ], 46, eo));
  }
});
function oo(t, e) {
  const n = e.getClassName, i = t.node.getName() !== void 0, s = S(() => {
    const p = [n(b.FLEXLAYOUT__TABSET_HEADER)], u = t.node.getClassNameHeader();
    return u && p.push(u), t.node.isActive() && p.push(n(b.FLEXLAYOUT__TABSET_SELECTED)), t.node.isMaximized() && p.push(n(b.FLEXLAYOUT__TABSET_MAXIMIZED)), p;
  }), a = t.node.getModel().isUseVisibility();
  function r() {
    return t.node.getModel().getMaximizedTabset() !== void 0 && !t.node.isMaximized();
  }
  const c = S(() => {
    const p = t.rect.styleWithPosition({});
    return r() && lt(p, a), p;
  });
  return {
    showHeader: i,
    style: c,
    tabHeaderClassList: s
  };
}
const no = ["data-layout-path"], et = /* @__PURE__ */ j({
  __name: "Header",
  props: {
    node: {},
    headerButtons: {},
    tabHeaderClasses: {},
    path: {}
  },
  setup(t) {
    const e = t, n = Z(), { onMousedown: i, onAuxMouseClick: s, onContextMenu: a } = Ue(e.node, n), r = n.getClassName, c = S(() => {
      const _ = n.dragNode?.value;
      return _ ? _ === e.node : !1;
    }), p = S(() => c.value ? "var(--common-pending)" : "var(--common-tertiary)"), u = S(() => {
      const _ = b.FLEXLAYOUT__TABSET_HEADER_CONTENT;
      return [r(_), c.value ? r(`${_}--dragging`) : ""];
    });
    return (_, f) => (l(), N("div", {
      class: D(_.tabHeaderClasses),
      style: V({ height: _.node.getHeaderHeight() + "px" }),
      "data-layout-path": `${_.path}/header`,
      onMousedown: f[0] || (f[0] = //@ts-ignore
      (...R) => o(i) && o(i)(...R)),
      onContextmenu: f[1] || (f[1] = //@ts-ignore
      (...R) => o(a) && o(a)(...R)),
      onClick: f[2] || (f[2] = //@ts-ignore
      (...R) => o(s) && o(s)(...R)),
      onAuxclick: f[3] || (f[3] = //@ts-ignore
      (...R) => o(s) && o(s)(...R)),
      onTouchstart: f[4] || (f[4] = //@ts-ignore
      (...R) => o(i) && o(i)(...R))
    }, [
      q("div", {
        class: D(u.value)
      }, [
        Q(o(We), {
          icon: "ellipsis-Andriod",
          size: "20",
          class: "mr-8",
          color: p.value
        }, null, 8, ["color"]),
        nt(" " + Be(_.node.getName()), 1)
      ], 2),
      Q(je, {
        ref: "toolbarRef",
        node: _.node,
        path: _.path,
        buttons: _.headerButtons,
        "sticky-buttons": [],
        "hidden-count": 0,
        "hidden-tabs": []
      }, null, 8, ["node", "path", "buttons"])
    ], 46, no));
  }
}), tt = /* @__PURE__ */ j({
  __name: "Center",
  props: {
    node: {}
  },
  setup(t) {
    const e = t, n = Z(), i = n.getClassName, s = S(() => {
      if (e.node.getChildren().length === 0) {
        const a = n.getTabSetPlaceHolderCallback();
        if (a)
          return a(e.node);
      }
      return null;
    });
    return (a, r) => (l(), N("div", {
      class: D(o(i)(o(b).FLEXLAYOUT__TABSET_CONTENT))
    }, [
      s.value ? (l(), U(G(s.value), { key: 0 })) : $("", !0)
    ], 2));
  }
});
function so() {
  return He("tabSet", {
    rect: new ce(0, 0, 0, 0),
    tabsTruncated: F(!1),
    setToolbarWidth: (t) => {
      console.log(t);
    },
    setStickyButtonsWidth: (t) => {
      console.log(t);
    }
  });
}
const ao = ["data-layout-path", "title"], io = ["data-layout-path", "value"], lo = ["data-layout-path", "title"], ro = /* @__PURE__ */ j({
  __name: "TabButton",
  props: {
    node: {},
    title: { default: "" },
    selected: { type: Boolean },
    path: {}
  },
  setup(t) {
    const e = t, n = Z(), { rect: i } = so(), { node: s, title: a } = Ie(e), r = F(null), c = F(null), p = F(!1), { icons: u } = n, _ = (L) => {
      !ve(L) && !n.getEditingTab() && n.dragStart(L, void 0, e.node, e.node.isEnableDrag(), I, E);
    }, f = (L) => {
      ve(L) && n.auxMouseClick(e.node, L);
    }, R = (L) => {
      n.showContextMenu(e.node, L);
    }, I = () => {
      n.doAction(Y.selectTab(e.node.getId()));
    }, E = () => {
      e.node.isEnableRename() && O();
    }, O = () => {
      p.value = !0, n.setEditingTab(e.node), document.body.addEventListener("mousedown", C), document.body.addEventListener("touchstart", C), Ye(() => {
        c.value?.focus();
      });
    }, C = (L) => {
      L.target !== c.value && (n.setEditingTab(void 0), p.value = !1, document.body.removeEventListener("mousedown", C), document.body.removeEventListener("touchstart", C));
    }, x = () => {
      const L = e.node.getCloseType();
      return !!(e.selected || L === De.Always || L === De.Visible && window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches);
    }, m = () => {
      x() ? n.doAction(Y.deleteTab(e.node)) : I();
    }, v = (L) => {
      L.stopPropagation();
    };
    fe(i, () => {
      Ye(k);
    }), be(() => {
      k(), n.getEditingTab() === e.node && c.value?.select();
    });
    const k = () => {
      if (!r.value)
        return;
      const L = n.getDomRect(), H = r.value.getBoundingClientRect();
      e.node._setTabRect(new ce(H.left - L.left, H.top - L.top, H.width, H.height));
    }, M = (L) => {
      L.stopPropagation();
    }, z = (L) => {
      const H = L.code === "Escape", te = L.code === "Enter" || L.code === "NumpadEnter";
      (H || te) && (n.setEditingTab(void 0), p.value = !1), te && n.doAction(Y.renameTab(e.node.getId(), c.value.value));
    }, y = n.getClassName, d = e.node.getParent(), B = b.FLEXLAYOUT__TAB_BUTTON, g = S(() => {
      const L = n.dragNode?.value;
      return L ? L === e.node : !1;
    }), T = S(() => {
      const L = [y(B)];
      L.push(y(B + "_" + d.getTabLocation())), L.push(e.selected ? y(B + "--selected") : y(B + "--unselected")), p.value && L.push(y(B + "--editing")), g.value && L.push(y(B + "--dragging"));
      const H = e.node.getClassName();
      return H && L.push(H), L;
    }), A = Ge({
      node: s,
      title: a
    });
    return (L, H) => (l(), N("div", {
      ref_key: "selfRef",
      ref: r,
      "data-layout-path": L.path,
      class: D(T.value),
      title: o(s).getHelpText(),
      role: "button",
      onMousedown: _,
      onClick: f,
      onAuxclick: f,
      onContextmenu: R,
      onTouchstart: _
    }, [
      o(A).leading ? (l(), U(G(o(A).leading), {
        key: 0,
        class: D(o(y)(o(b).FLEXLAYOUT__TAB_BUTTON_LEADING))
      }, null, 8, ["class"])) : $("", !0),
      o(n).getEditingTab() === o(s) ? (l(), N("input", {
        key: 1,
        ref_key: "contentRef",
        ref: c,
        class: D(o(y)(o(b).FLEXLAYOUT__TAB_BUTTON_TEXTBOX)),
        "data-layout-path": `${e.path}/textbox`,
        type: "text",
        value: o(a),
        autoFocus: "",
        onKeydown: z,
        onMousedown: M,
        onTouchstart: M
      }, null, 42, io)) : (l(), U(G(o(A).content), {
        key: 2,
        class: D(o(y)(o(b).FLEXLAYOUT__TAB_BUTTON_CONTENT))
      }, null, 8, ["class"])),
      L.selected && o(s).isEnableClose() ? (l(), N("div", {
        key: "close",
        "data-layout-path": `${e.path}/button/close`,
        title: o(n).i18nName(o(ue).Close_Tab),
        class: D(o(y)(o(b).FLEXLAYOUT__TAB_BUTTON_TRAILING)),
        onMousedown: v,
        onClick: m,
        onTouchstart: v
      }, [
        o(u).close ? (l(), U(G(typeof o(u).close == "function" ? o(u).close(o(s)) : o(u).close), { key: 0 })) : $("", !0)
      ], 42, lo)) : $("", !0)
    ], 42, ao));
  }
}), co = ["data-layout-path"], ot = /* @__PURE__ */ j({
  __name: "TabStrip",
  props: {
    node: {},
    tabSetRenderValues: {},
    path: {},
    showHeader: { type: Boolean },
    selectedTabNode: {}
  },
  setup(t) {
    const e = t, n = Z(), { onMousedown: i, onContextMenu: s, onAuxMouseClick: a, onInterceptMouseDown: r } = Ue(e.node, n), c = n.getClassName, p = xe(e, "node"), u = xe(e, "selectedTabNode"), { selfRef: _, stickyButtonsRef: f, toolbarRef: R, hiddenTabs: I, hiddenCount: E, position: O } = ct({
      node: p,
      selectedTabNode: u
    }), C = { height: e.node.getTabStripHeight() + "px" }, x = S(() => {
      const B = [c(b.FLEXLAYOUT__TABSET_TABBAR_OUTER)], g = e.node.getClassNameTabStrip();
      return g && B.push(g), e.node.isActive() && !e.showHeader && B.push(c(b.FLEXLAYOUT__TABSET_SELECTED)), e.node.isMaximized() && !e.showHeader && B.push(c(b.FLEXLAYOUT__TABSET_MAXIMIZED)), B;
    }), m = F(null), v = S(() => [c(b.FLEXLAYOUT__TABSET_TABBAR_INNER), c(b.FLEXLAYOUT__TABSET_TABBAR_INNER_ + e.node.getTabLocation())]), k = S(() => [c(b.FLEXLAYOUT__TABSET_TABBAR_INNER_TAB_CONTAINER), c(b.FLEXLAYOUT__TABSET_TABBAR_INNER_TAB_CONTAINER_ + e.node.getTabLocation())]), M = xe(e, "tabSetRenderValues"), z = S(() => {
      const B = [];
      if (e.node.isEnableTabStrip())
        for (let g = 0; g < e.node.getChildren().length; g++) {
          const T = e.node.getChildren()[g], A = e.node.getSelected() === g;
          B.push(
            {
              node: T,
              title: T.getName(),
              path: `${e.path}/tb${g}`,
              key: T.getId(),
              selected: A,
              type: "tab-button"
            }
          ), g < e.node.getChildren().length - 1 && B.push({
            type: "divider",
            class: c(b.FLEXLAYOUT__TABSET_TAB_DIVIDER)
          });
        }
      return B;
    }), y = S(() => M.value.stickyButtons), d = S(() => M.value.buttons);
    return be(() => {
      m.value !== null && m.value.scrollLeft !== 0 && (m.value.scrollLeft = 0);
    }), (B, g) => (l(), N("div", {
      ref_key: "selfRef",
      ref: _,
      style: C,
      class: D(x.value),
      "data-layout-path": `${B.path}/tabstrip`,
      onMousedown: g[3] || (g[3] = //@ts-ignore
      (...T) => o(i) && o(i)(...T)),
      onTouchstart: g[4] || (g[4] = //@ts-ignore
      (...T) => o(i) && o(i)(...T)),
      onContextmenu: g[5] || (g[5] = //@ts-ignore
      (...T) => o(s) && o(s)(...T)),
      onClick: g[6] || (g[6] = //@ts-ignore
      (...T) => o(a) && o(a)(...T))
    }, [
      q("div", {
        ref_key: "tabbarInnerRef",
        ref: m,
        class: D(v.value)
      }, [
        q("div", {
          class: D(k.value),
          style: V({ left: o(O) + "px" })
        }, [
          (l(!0), N(W, null, ee(z.value, (T) => (l(), N(W, null, [
            T.type === "tab-button" ? (l(), U(ro, {
              key: T.key,
              node: T.node,
              path: T.path,
              selected: T.selected,
              title: T.title
            }, null, 8, ["node", "path", "selected", "title"])) : T.type === "divider" ? (l(), N("div", {
              key: T.key,
              class: D(T.class)
            }, null, 2)) : $("", !0)
          ], 64))), 256)),
          y.value.length && !o(E) ? (l(), N("div", {
            key: "sticky_buttons_container",
            ref_key: "stickyButtonsRef",
            ref: f,
            class: D(o(c)(o(b).FLEXLAYOUT__TAB_TOOLBAR_STICKY_BUTTONS_CONTAINER)),
            onMousedown: g[0] || (g[0] = //@ts-ignore
            (...T) => o(r) && o(r)(...T)),
            onTouchstart: g[1] || (g[1] = //@ts-ignore
            (...T) => o(r) && o(r)(...T)),
            onDragstart: g[2] || (g[2] = (T) => {
              T.preventDefault();
            })
          }, [
            (l(!0), N(W, null, ee(y.value, (T, A) => (l(), U(G(T), { key: A }))), 128))
          ], 34)) : $("", !0)
        ], 6)
      ], 2),
      Q(je, {
        ref_key: "toolbarRef",
        ref: R,
        node: p.value,
        path: B.path,
        buttons: d.value,
        "sticky-buttons": y.value,
        "hidden-count": o(E),
        "hidden-tabs": o(I)
      }, null, 8, ["node", "path", "buttons", "sticky-buttons", "hidden-count", "hidden-tabs"])
    ], 42, co));
  }
}), uo = ["data-layout-path"], fo = /* @__PURE__ */ j({
  __name: "index",
  props: {
    node: {},
    rect: {},
    path: {}
  },
  setup(t) {
    const e = t, n = Z(), { style: i, showHeader: s, tabHeaderClassList: a } = oo(e, n), r = S(() => e.node.getSelectedNode()), c = F(n.customizeTabSet(e.node));
    vt(
      e.node.getChildren(),
      () => {
        c.value = n.customizeTabSet(e.node);
      },
      { debounce: 10 }
    );
    const p = F(null), u = S(() => e.node.isEnableTabStrip()), _ = n.getClassName;
    return Fe("tabSet", {
      rect: Ve(() => e.rect)
    }), (f, R) => (l(), N("div", {
      ref_key: "selfRef",
      ref: p,
      dir: "ltr",
      "data-layout-path": f.path,
      style: V(o(i)),
      class: D(o(_)(o(b).FLEXLAYOUT__TABSET))
    }, [
      f.node.getTabLocation() === "top" ? (l(), N(W, { key: 0 }, [
        o(s) ? (l(), U(et, {
          key: 0,
          "header-buttons": c.value.headerButtons,
          node: f.node,
          path: f.path,
          "tab-header-classes": o(a)
        }, null, 8, ["header-buttons", "node", "path", "tab-header-classes"])) : $("", !0),
        u.value ? (l(), U(ot, {
          key: 1,
          node: f.node,
          path: f.path,
          "show-header": o(s),
          "selected-tab-node": r.value,
          "tab-set-render-values": c.value
        }, null, 8, ["node", "path", "show-header", "selected-tab-node", "tab-set-render-values"])) : $("", !0),
        Q(tt, { node: f.node }, null, 8, ["node"])
      ], 64)) : (l(), N(W, { key: 1 }, [
        o(s) ? (l(), U(et, {
          key: 0,
          "header-buttons": c.value.headerButtons,
          node: f.node,
          path: f.path,
          "tab-header-classes": o(a),
          "tab-set-render-values": c.value
        }, null, 8, ["header-buttons", "node", "path", "tab-header-classes", "tab-set-render-values"])) : $("", !0),
        Q(tt, { node: f.node }, null, 8, ["node"]),
        u.value ? (l(), U(ot, {
          key: 1,
          node: f.node,
          path: f.path,
          "show-header": o(s),
          "selected-tab-node": r.value,
          "tab-set-render-values": c.value
        }, null, 8, ["node", "path", "show-header", "selected-tab-node", "tab-set-render-values"])) : $("", !0)
      ], 64))
    ], 14, uo));
  }
}), go = ["innerHTML"], ho = /* @__PURE__ */ j({
  __name: "DragRect",
  props: {
    show: { type: Boolean },
    text: {},
    node: {},
    json: {},
    position: {},
    containerRect: {},
    isCenter: { type: Boolean },
    onRendered: { type: Function },
    onRenderDragRect: { type: Function }
  },
  setup(t) {
    const e = t, n = F(null), i = Z(), { width: s } = Me(n), a = S(() => e.node instanceof ye), r = S(() => e.onRenderDragRect ? e.onRenderDragRect(null, e.node, e.json) : null), c = S(() => {
      const { position: u, containerRect: _ } = e;
      let f = u.x - s.value / 2;
      return f + s.value > _.width && (f = _.width - s.value), f = Math.max(0, f), {
        left: f + "px",
        top: u.y + 5 + "px"
      };
    }), p = (u) => {
      u.preventDefault(), i.dragStart(u, e.text, ye._fromJson(e.json, i.model, !1), !0, void 0, void 0);
    };
    return (u, _) => u.show ? (l(), N("div", {
      key: 0,
      ref_key: "dragRectRef",
      ref: n,
      "data-layout-path": "/drag-rectangle",
      "aria-hidden": "",
      class: D(o(b).FLEXLAYOUT__DRAG_RECT),
      style: V(c.value),
      onMousedown: p,
      onTouchstartPassive: p
    }, [
      u.text ? (l(), N("div", {
        key: 0,
        style: { "white-space": "pre" },
        innerHTML: u.text
      }, null, 8, go)) : a.value && u.node ? (l(), U(rt, {
        key: 1,
        node: u.node,
        title: u.node.getName()
      }, null, 8, ["node", "title"])) : r.value ? (l(), U(G(r.value), { key: 2 })) : $("", !0)
    ], 38)) : $("", !0);
  }
}), po = /* @__PURE__ */ j({
  __name: "Outline",
  props: {
    show: { type: Boolean },
    className: {},
    rect: { default: () => new ce(0, 0, 0, 0) },
    speed: { default: 0.3 }
  },
  setup(t) {
    const e = t, { speed: n } = e, i = `top ${n}s, left ${n}s, width ${n}s, height ${n}s`, s = S(() => {
      const { x: a, y: r, width: c, height: p } = e.rect;
      return {
        top: `${r}px`,
        left: `${a}px`,
        width: `${c}px`,
        height: `${p}px`,
        position: "absolute",
        transition: i
      };
    });
    return (a, r) => a.show ? (l(), N("div", {
      key: 0,
      class: D(a.className),
      style: V(s.value)
    }, null, 6)) : $("", !0);
  }
}), To = ["className"], Do = /* @__PURE__ */ j({
  name: "e-flex-layout",
  __name: "Layout",
  props: {
    model: {},
    factory: { type: Function },
    font: {},
    fontFamily: {},
    iconFactory: { type: Function },
    titleFactory: { type: Function },
    icons: {},
    onAction: { type: Function },
    onRenderTab: { type: Function },
    onRenderTabSet: { type: Function },
    onModelChange: { type: Function },
    onExternalDrag: { type: Function },
    classNameMapper: { type: Function },
    i18nMapper: { type: Function },
    supportsPopout: { type: Boolean },
    popoutURL: {},
    realtimeResize: { type: Boolean },
    logEnabled: { type: Boolean },
    onTabDrag: { type: Function },
    onRenderDragRect: { type: Function },
    onRenderFloatingTabPlaceholder: { type: Function },
    onContextMenu: { type: Function },
    onAuxMouseClick: { type: Function },
    onShowOverflowMenu: { type: Function },
    onTabSetPlaceHolder: { type: Function },
    onTabConfigChange: { type: Function },
    onError: { type: Function }
  },
  setup(t, { expose: e }) {
    const n = t, i = F(n.model), s = F();
    let a;
    const {
      selfRef: r,
      state: c,
      portal: p,
      supportsPopout: u,
      getClassName: _,
      styleFont: f,
      updateRect: R,
      addTabToTabSet: I,
      addTabWithDragAndDrop: E,
      replaceTab: O,
      removeTab: C,
      onCloseWindow: x,
      onSetWindow: m,
      getDomRect: v,
      maximize: k,
      popoutURL: M,
      addTabWithDragAndDropIndirect: z,
      dragRectProps: y,
      outlineProps: d
    } = Lt(n), { findHeaderBarSizeRef: B, findTabBarSizeRef: g, findBorderBarSizeRef: T, metrics: A, updateLayoutMetrics: L } = Bt(), { borderComponents: H, tabSetComponents: te, floatingWindows: se, tabComponents: oe, splitterComponents: le, resetComponents: ze } = wt(), { renderChildren: Pe, renderBorder: _e } = Nt({
      iconFactory: n.iconFactory,
      titleFactory: n.titleFactory,
      icons: it,
      factory: n.factory,
      supportsPopout: u,
      popoutURL: M,
      onTabConfigChange: n.onTabConfigChange,
      onCloseWindow: x,
      onSetWindow: m,
      getDomRect: v
    }), me = f({ visibility: "hidden" }), Re = F([]);
    function Ae(he) {
      ge(), n.onModelChange && n.onModelChange(i.value, he);
    }
    const Ne = F(!1), $e = at({ enabled: n.logEnabled, plain: !0 });
    function ge() {
      $e.info("[FlexLayout] init is called"), R(), L(), s.value = i.value._layout(c.rect, A), ze(), _e(i.value.getBorderSet(), H.value, oe.value, se.value, le.value), Pe("", i.value.getRoot(), te.value, oe.value, se.value, le.value);
      const { existingIds: he, newIds: Se } = Object.keys(oe.value).reduce((X, Ee) => (Re.value.includes(Ee) ? X.existingIds.push(Ee) : X.newIds.push(Ee), X), { existingIds: [], newIds: [] });
      Re.value = [...he, ...Se];
    }
    return be(() => {
      ge(), Ne.value = !0, i.value._setChangeListener(Ae), a = new ResizeObserver(() => {
        ge();
      }), a.observe(r.value);
    }), pt(() => {
      n.model !== i.value && (i.value._setChangeListener(void 0), i.value = n.model, i.value._setChangeListener(Ae), ge());
    }), Tt(() => {
      a.unobserve(r.value);
    }), e({
      addTabToTabSet: I,
      addTabWithDragAndDrop: E,
      addTabWithDragAndDropIndirect: z,
      replaceTab: O,
      removeTab: C,
      maximize: k
    }), (he, Se) => (l(), N("div", {
      ref_key: "selfRef",
      ref: r,
      class: D(o(_)(o(b).FLEXLAYOUT__LAYOUT))
    }, [
      Ne.value ? (l(), N(W, { key: 0 }, [
        (l(!0), N(W, null, ee(o(le), (X) => (l(), U(Kt, {
          key: X.key,
          rect: X.rect,
          node: X.node,
          path: X.path
        }, null, 8, ["rect", "node", "path"]))), 128)),
        (l(!0), N(W, null, ee(o(te), (X) => (l(), U(fo, {
          key: X.key,
          node: X.node,
          rect: X.rect,
          path: X.path
        }, null, 8, ["node", "rect", "path"]))), 128)),
        (l(!0), N(W, null, ee(Re.value, (X) => (l(), U(to, st({
          key: o(oe)[X].key,
          ref_for: !0
        }, o(oe)[X]), null, 16))), 128)),
        (l(!0), N(W, null, ee(o(H), (X) => (l(), U(jt, {
          key: X.key,
          border: X.node,
          rect: X.rect,
          path: X.path
        }, null, 8, ["border", "rect", "path"]))), 128))
      ], 64)) : $("", !0),
      o(p) ? (l(), U(G(o(p)), { key: 1 })) : $("", !0),
      q("div", {
        key: "findHeaderBarSize",
        ref_key: "findHeaderBarSizeRef",
        ref: B,
        style: V(o(me)),
        class: D(o(_)(o(b).FLEXLAYOUT__TABSET_HEADER_SIZER))
      }, " FindHeaderBarSize ", 6),
      q("div", {
        key: "findTabBarSize",
        ref_key: "findTabBarSizeRef",
        ref: g,
        style: V(o(me)),
        className: o(_)(o(b).FLEXLAYOUT__TABSET_SIZER)
      }, " FindTabBarSize ", 12, To),
      q("div", {
        key: "findBorderBarSize",
        ref_key: "findBorderBarSizeRef",
        ref: T,
        style: V(o(me)),
        class: D(o(_)(o(b).FLEXLAYOUT__BORDER_SIZER))
      }, " FindBorderBarSize ", 6),
      Q(ho, Ke(qe(o(y))), null, 16),
      Q(po, Ke(qe(o(d))), null, 16),
      o(c).showEdges ? (l(), U(Jt, {
        key: 2,
        "center-rect": s.value
      }, null, 8, ["center-rect"])) : $("", !0)
    ], 2));
  }
});
export {
  Do as default
};
//# sourceMappingURL=flex-layout.js.map
